import userActionTypes from './userActionTypes';

const toggleDarkMode = () => ({
  type: userActionTypes.TOGGLE_DARK_MODE,
});

export default {
  toggleDarkMode,
};
